import { AlbType } from './albType';
import { ChasubleType } from './chasubleType';
import { StoleType } from './stoleType';
import { VestmentCategory } from './vestmentCategory';

export enum VestmentType {
  ChasubleCenterDesign = 'chasuble_center_design',
  ChasubleCenterPatch = 'chasuble_center_patch',
  ChasubleTauOrphrey = 'chasuble_tau_orphrey',
  ChasubleDirectEmbroideryDesign = 'chasuble_direct_embroidery_design',
  ChasubleGothicStyle = 'chasuble_gothic_style',
  ChasubleAlb = 'chasuble_alb',
  ChasublePlain = 'chasuble_plain',
  ChasubleRoman = 'chasuble_roman',
  ChasubleV1Orphrey = 'chasuble_v1_orphrey',
  ChasubleV1Plain = 'chasuble_v1_plain',
  AlbOverlapping = 'alb_overlapping',
  AlbRoman = 'alb_roman',
  AlbRomanSideZipper = 'alb_roman_side_zipper',
  AlbPoland = 'alb_poland',
  AlbSurplice = 'alb_surplice',
  AlbAmerican = 'alb_american',
  AlbMonastic = 'alb_monastic',
  AlbV1Roman = 'alb_v1_roman',
  AlbV1NonRoman = 'alb_v1_non_roman',
  AlbV1Surplice = 'alb_v1_surplice',
  StoleFlatPriest = 'stole_flat_priest',
  StoleStandingBackPriest = 'stole_standing_back_priest',
  StolePastoralPriest = 'stole_pastoral_priest',
  StoleDeacon = 'stole_deacon',
  StoleV1Ordinary = 'stole_v1_ordinary',
  StoleV1Special = 'stole_v1_special',
  StoleV1RomanOrdinary = 'stole_v1_roman_ordinary',
  StoleV1RomanSpecial = 'stole_v1_roman_special',
  StoleV1DeaconStraight = 'stole_v1_deacon_straight',
  StoleV1DeaconLShaped = 'stole_v1_deacon_l_shaped',
  Mitre = 'mitre',
}

export function getCategory(type: VestmentType): VestmentCategory {
  switch (type) {
    case VestmentType.ChasubleCenterDesign:
    case VestmentType.ChasubleCenterPatch:
    case VestmentType.ChasubleTauOrphrey:
    case VestmentType.ChasubleDirectEmbroideryDesign:
    case VestmentType.ChasubleGothicStyle:
    case VestmentType.ChasubleAlb:
    case VestmentType.ChasublePlain:
    case VestmentType.ChasubleRoman:
    case VestmentType.ChasubleV1Orphrey:
    case VestmentType.ChasubleV1Plain:
      return VestmentCategory.Chasuble;
    case VestmentType.AlbOverlapping:
    case VestmentType.AlbRoman:
    case VestmentType.AlbRomanSideZipper:
    case VestmentType.AlbPoland:
    case VestmentType.AlbSurplice:
    case VestmentType.AlbAmerican:
    case VestmentType.AlbMonastic:
    case VestmentType.AlbV1Roman:
    case VestmentType.AlbV1NonRoman:
    case VestmentType.AlbV1Surplice:
      return VestmentCategory.Alb;
    case VestmentType.StoleFlatPriest:
    case VestmentType.StoleStandingBackPriest:
    case VestmentType.StolePastoralPriest:
    case VestmentType.StoleDeacon:
    case VestmentType.StoleV1Ordinary:
    case VestmentType.StoleV1Special:
    case VestmentType.StoleV1RomanOrdinary:
    case VestmentType.StoleV1RomanSpecial:
    case VestmentType.StoleV1DeaconStraight:
    case VestmentType.StoleV1DeaconLShaped:
      return VestmentCategory.Stole;
    case VestmentType.Mitre:
      return VestmentCategory.Mitre;
    default: {
      const _exhaustive: never = type;
      return _exhaustive;
    }
  }
}

export function getSubtype(
  type: VestmentType
): ChasubleType | AlbType | StoleType | null {
  switch (type) {
    case VestmentType.ChasubleCenterDesign:
      return ChasubleType.CenterDesign;
    case VestmentType.ChasubleCenterPatch:
      return ChasubleType.CenterPatch;
    case VestmentType.ChasubleTauOrphrey:
      return ChasubleType.TauOrphrey;
    case VestmentType.ChasubleDirectEmbroideryDesign:
      return ChasubleType.DirectEmbroideryDesign;
    case VestmentType.ChasubleGothicStyle:
      return ChasubleType.GothicStyle;
    case VestmentType.ChasubleAlb:
      return ChasubleType.Alb;
    case VestmentType.ChasublePlain:
      return ChasubleType.Plain;
    case VestmentType.ChasubleRoman:
      return ChasubleType.Roman;
    case VestmentType.ChasubleV1Orphrey:
      return ChasubleType.V1Orphrey;
    case VestmentType.ChasubleV1Plain:
      return ChasubleType.V1Plain;
    case VestmentType.AlbOverlapping:
      return AlbType.Overlapping;
    case VestmentType.AlbRoman:
      return AlbType.Roman;
    case VestmentType.AlbRomanSideZipper:
      return AlbType.RomanSideZipper;
    case VestmentType.AlbPoland:
      return AlbType.Poland;
    case VestmentType.AlbSurplice:
      return AlbType.Surplice;
    case VestmentType.AlbAmerican:
      return AlbType.American;
    case VestmentType.AlbMonastic:
      return AlbType.Monastic;
    case VestmentType.AlbV1Roman:
      return AlbType.V1Roman;
    case VestmentType.AlbV1NonRoman:
      return AlbType.V1NonRoman;
    case VestmentType.AlbV1Surplice:
      return AlbType.V1Surplice;
    case VestmentType.StoleFlatPriest:
      return StoleType.FlatPriest;
    case VestmentType.StoleStandingBackPriest:
      return StoleType.StandingBackPriest;
    case VestmentType.StolePastoralPriest:
      return StoleType.PastoralPriest;
    case VestmentType.StoleDeacon:
      return StoleType.Deacon;
    case VestmentType.StoleV1Ordinary:
      return StoleType.V1Ordinary;
    case VestmentType.StoleV1Special:
      return StoleType.V1Special;
    case VestmentType.StoleV1RomanOrdinary:
      return StoleType.V1RomanOrdinary;
    case VestmentType.StoleV1RomanSpecial:
      return StoleType.V1RomanSpecial;
    case VestmentType.StoleV1DeaconStraight:
      return StoleType.V1DeaconStraight;
    case VestmentType.StoleV1DeaconLShaped:
      return StoleType.V1DeaconLShaped;
    case VestmentType.Mitre:
      return null;
    default: {
      const _exhaustive: never = type;
      return _exhaustive;
    }
  }
}

export function fromCategoryAndSubtype(
  category: VestmentCategory,
  subtype: ChasubleType | AlbType | StoleType | null
): VestmentType {
  if (category === VestmentCategory.Mitre) {
    if (subtype !== null) {
      throw new Error('Mitre has no subtype.');
    }
    return VestmentType.Mitre;
  } else if (subtype === null) {
    throw new Error(`Subtype is required for ${category} vestments.`);
  }
  switch (category) {
    case VestmentCategory.Chasuble:
      switch (subtype as ChasubleType) {
        case ChasubleType.CenterDesign:
          return VestmentType.ChasubleCenterDesign;
        case ChasubleType.CenterPatch:
          return VestmentType.ChasubleCenterPatch;
        case ChasubleType.TauOrphrey:
          return VestmentType.ChasubleTauOrphrey;
        case ChasubleType.DirectEmbroideryDesign:
          return VestmentType.ChasubleDirectEmbroideryDesign;
        case ChasubleType.GothicStyle:
          return VestmentType.ChasubleGothicStyle;
        case ChasubleType.Alb:
          return VestmentType.ChasubleAlb;
        case ChasubleType.Plain:
          return VestmentType.ChasublePlain;
        case ChasubleType.Roman:
          return VestmentType.ChasubleRoman;
        case ChasubleType.V1Orphrey:
          return VestmentType.ChasubleV1Orphrey;
        case ChasubleType.V1Plain:
          return VestmentType.ChasubleV1Plain;
        default:
          throw new Error('Invalid chasuble subtype.');
      }
    case VestmentCategory.Alb:
      switch (subtype as AlbType) {
        case AlbType.Overlapping:
          return VestmentType.AlbOverlapping;
        case AlbType.Roman:
          return VestmentType.AlbRoman;
        case AlbType.RomanSideZipper:
          return VestmentType.AlbRomanSideZipper;
        case AlbType.Poland:
          return VestmentType.AlbPoland;
        case AlbType.Surplice:
          return VestmentType.AlbSurplice;
        case AlbType.American:
          return VestmentType.AlbAmerican;
        case AlbType.Monastic:
          return VestmentType.AlbMonastic;
        case AlbType.V1Roman:
          return VestmentType.AlbV1Roman;
        case AlbType.V1NonRoman:
          return VestmentType.AlbV1NonRoman;
        case AlbType.V1Surplice:
          return VestmentType.AlbV1Surplice;
        default:
          throw new Error('Invalid alb subtype.');
      }
    case VestmentCategory.Stole:
      switch (subtype as StoleType) {
        case StoleType.FlatPriest:
          return VestmentType.StoleFlatPriest;
        case StoleType.StandingBackPriest:
          return VestmentType.StoleStandingBackPriest;
        case StoleType.PastoralPriest:
          return VestmentType.StolePastoralPriest;
        case StoleType.Deacon:
          return VestmentType.StoleDeacon;
        case StoleType.V1Ordinary:
          return VestmentType.StoleV1Ordinary;
        case StoleType.V1Special:
          return VestmentType.StoleV1Special;
        case StoleType.V1RomanOrdinary:
          return VestmentType.StoleV1RomanOrdinary;
        case StoleType.V1RomanSpecial:
          return VestmentType.StoleV1RomanSpecial;
        case StoleType.V1DeaconStraight:
          return VestmentType.StoleV1DeaconStraight;
        case StoleType.V1DeaconLShaped:
          return VestmentType.StoleV1DeaconLShaped;
        default:
          throw new Error('Invalid stole subtype.');
      }
    default: {
      const _exhaustive: never = category;
      return _exhaustive;
    }
  }
}

export function isV1VestmentType(type: VestmentType): boolean {
  return (
    type === VestmentType.ChasubleV1Orphrey ||
    type === VestmentType.ChasubleV1Plain ||
    type === VestmentType.StoleV1Ordinary ||
    type === VestmentType.StoleV1Special ||
    type === VestmentType.StoleV1RomanOrdinary ||
    type === VestmentType.StoleV1RomanSpecial ||
    type === VestmentType.StoleV1DeaconStraight ||
    type === VestmentType.StoleV1DeaconLShaped ||
    type === VestmentType.AlbV1Roman ||
    type === VestmentType.AlbV1NonRoman ||
    type === VestmentType.AlbV1Surplice
  );
}
